import { Instance, types } from 'mobx-state-tree';

const StudentProgramsGrade = types.model('Grade', {
	id: types.identifierNumber,
	comment: types.maybeNull(types.string),
	created_at: types.string,
	// TODO remove after
	grade: types.maybeNull(types.string),
	grade_type_id: types.maybeNull(types.number),
	manual_grade: types.maybeNull(types.string),
});

export interface IStudentProgramsGradeModel extends Instance<typeof StudentProgramsGrade> {}

export default StudentProgramsGrade;
